import { Component, OnInit } from '@angular/core';
import { Http, Response } from "@angular/http";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../environments/environment";
import { FormsModule } from '@angular/forms';
import { appService } from '../_services/app.service';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { Helpers } from "../helpers";
import { TranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from '../theme/home/translateConfig.service';
declare var $: any;
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: 'app-track-by-no',
  templateUrl: './track-by-no.component.html',
  styleUrls: ['./track-by-no.component.scss']
})

export class TrackByNoComponent implements OnInit {

  trackid: string = '';
  bookingId: any;
  WhiteLabel: any;

  orderByOrderNo: any = {};
  //added by vithujan 03-01-2024 - Siddarth
  hostUrl: any = environment.apiUrl;
  selectedLang: string;

  constructor(
    private toastr: ToastrService,
    private http: Http,
    private _appService: appService,
    private _script: ScriptLoaderService,
    private translate: TranslateService,
    private service: TranslateConfigService,) {
    let language = 'en';
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage('en');
      this.selectedLang = 'en';
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this._script
      .loadScripts(
        "body",
        [
          "assets/vendors/base/vendors.bundle.js",
          "assets/demo/default/base/scripts.bundle.js"
        ],
        true
      )
      .then(() => {
        this.getWhiteLable();
        setTimeout(() => {
          $('input:radio[name="in_TripOrderRad"]').filter('[value="Trip"]').attr("checked", "true");
        }, 200);
      });
  }

  getBookingId() {
    var SearchType: any = $("input[name='in_TripOrderRad']:checked").val();
    this._appService.GetByTwoId("TrackByNo", "TrackByNo", this.trackid, SearchType).subscribe((response) => {
      var data: any = [];
      data = response;
      var url = '';
      if (data.length == 0) {
        this.toastr.error("Number Does Not Exist!", "warning");
      } else if (data.length != 0) {
        this.bookingId = data[0].Id;
        var condetailsid = null;
        condetailsid = data[0].condetailsid;
        if (SearchType == 'Order') {
          if (this.hostUrl == 'http://localhost:601441/') {
            url = '/courier-tracking?tracking-no=' + data[0].ReferenceNo;
          } else if (this.hostUrl == 'https://jcc.ifreightbox.net/') {
            url = '/Newtracking?id=' + this.bookingId;
          }
          else {
            url = '/LiveTracking_ByOrder?orderId=' + this.bookingId;
          }
        } else {
          url = '/LiveTracking?bookingId=' + this.bookingId + '&consignmentDetailId=' + condetailsid;
        }
        window.open(url).focus();
      }
      else {
        this.toastr.error("Number Does Not Exist!", "warning");
      }
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      }
    );
    // this.trackByNo(this.trackid).subscribe((data) => {
    //   if (data.length == 0) {
    //     this.toastr.error("Number Does Not Exist!", "warning");
    //   } else if (data.length != 0) {
    //     this.bookingId = data[0].Id;
    //     var condetailsid = null;
    //     condetailsid = data[0].condetailsid;
    //     var url = '/LiveTracking?bookingId=' + this.bookingId + '&consignmentDetailId=' + condetailsid;
    //     window.open(url).focus();
    //   }
    //   else {
    //     this.toastr.error("Number Does Not Exist!", "warning");
    //   }
    // },
    //   (error) => {
    //     this.toastr.error("An error occured  !", "error");
    //   });
  }

  //added by maaria
  GetTrackingNumberByOrderId() {
    if ($("input[name='in_TripOrderRad']:checked").val() == 'EWayBill') {
      this._appService
        .PostOrderNo(
          "OrdersByVehicle",
          "GetTrackingNumberByOrderNo",
          this.trackid
        )
        .subscribe(
          (response) => {
            this.orderByOrderNo = response[0];
            if (this.orderByOrderNo && !this.orderByOrderNo.TrackingNumber) {
              window.open("/LiveOrderTrack?orderId=" + this.orderByOrderNo.Id, '_blank');
            }
            else if (this.orderByOrderNo && !this.orderByOrderNo.TrackingNumber) {
              this.toastr.error("Tracking Number Does Not Exist!", "warning");
            }
            else {
              this.toastr.error("Number Does Not Exist!", "warning");
            }
          },
          (err) => {
            console.log(err);
            Helpers.setLoading(false);
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
          }
        );
    } else if ($("input[name='in_TripOrderRad']:checked").val() == 'Courier') {
      this._appService
        .GetById(
          "OrdersByVehicle",
          "GetTrackingNumberForCourier",
          this.trackid
        )
        .subscribe(
          (response) => {
            this.orderByOrderNo = response[0];

            if (response.length > 0) {
              window.open('/courier-tracking?tracking-no=' + this.orderByOrderNo.CourierConsignmentNo, '_blank');
            }
            else {
              this.toastr.error("Number Does Not Exist!", "warning");
            }
          },
          (err) => {
            console.log(err);
            Helpers.setLoading(false);
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
          }
        );
    } else {
      this.getBookingId();
    }
  }
  //end

  // add kevin 22/06/2021
  getWhiteLable() {
    this.getByIdWhiteLable('WhiteLabel').subscribe((data) => {
      this.WhiteLabel = data;
    },
      (error) => {
        this.toastr.error("An error occured  !", "error");
      });
  }
  // end

  trackByNo(Id: any) {
    return this.http.get(environment.apiUrl + 'api/TrackByNo/TrackByNo/?Id=' + Id + '&param1=null').map((response: Response) => response.json());
  }

  getByIdWhiteLable(id: string) {
    return this.http.get(environment.apiUrl + 'api/Common/GetSystemSettingByName/' + id).map((response: Response) => response.json());
  }

}
